import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { getAtmosphereChart } from '../../utils/utils';
import { POSITIVE_COLOR, NEGATIVE_COLOR } from '../../utils/constants';
import Percentage from './percentage';

const useStyles = makeStyles(theme => ({
    primary: {
        fontSize: 18,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
    },
    primaryLight: {
        fontWeight: 500,
        color: '#fff'
    },
    primaryDark: {
        fontWeight: 700,
        color: '#112435'
    },
    negative: {
        color: NEGATIVE_COLOR,
    },
    positive: {
        color: POSITIVE_COLOR
    },
    percentageLight: {
        fontWeight: 700
    },  
    icon: {
        width: 40, 
        height: 22, 
        transform: 'rotate(-10deg)',
        marginRight: 7
    }
}));

const Conversation = ({ atmosphere, value, percentage , theme}) => {
    const classes = useStyles();

    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <img 
                src={(atmosphere === 'NONE' || !atmosphere) ? getAtmosphereChart('negative'): getAtmosphereChart(atmosphere)} 
                alt="chart" 
                className={classes.icon} 
            />
            <Typography
                className={clsx(
                    theme? classes.primaryLight: classes.primaryDark, 
                    classes.primary
                )}
            >
                {value}
            </Typography>
            { percentage != null && <Percentage percentage={percentage} theme={theme} />}
        </Box>
    )
}

export default Conversation;
